<template>
  <div v-if="content" v-editable="content" id="seminaires">
    <component :content="blok" :key="blok._uid" v-for="(blok) in content.body" :is="blok.component"></component>
  </div>
</template>

<script>
  import api from "@/api";

  export default {
    data() {
      return {
        content: null
      };
    },
    created() {
      this.fetchData();
    },
    methods: {
      async fetchData() {
        try {
          const res = await api.get(
            `cdn/stories/${this.$i18n.locale}/pages/seminaires-perches-new-version`
          );
          this.content = res.data.story.content;
        } catch (err) {
          this.$router.push("/404");
        }
      }
    }
  };
</script>

<style lang="scss">
  #seminaires {
    font-family: "Muli", sans-serif;
    font-weight: 700;
    .grid-seminaire {
      .item-seminaire {
        .content {
          .content-text {
            right: -33px;
          }
        }
      }
    }
    .textBloc {
      width: 100%;
      font-family: "Muli", sans-serif;
    }
    .slider {
      .control {
        color: rgba(255, 255, 255, 1);
        z-index: 1;
      }
      .slides {
        li {
          &::after {
            background-color: rgba(0, 0, 0, 0);
          }
        }
      }
      .slilde-content {
        svg {
          color: white;
        }
      }
    }
    .bloc-image {
      position: absolute;
      z-index: 1;
      max-width: 20%;
      left: 40%;
      top: 15px;
      img {
        width: 70%;
        min-width: 200px;
        margin: auto;
      }
    }
    .title {
      padding-bottom: 15px;
      font-family: "Muli", sans-serif;
      text-transform: uppercase;
    }

    #contact-component {
      text-align: center;
      .success {
        color: #5ec26c;
        p {
          font-size:20px;
        }
      }
      .form-title {
        text-transform: uppercase;
        border-bottom: solid 5px rgb(94, 194, 108);
        display: inline-block;
        margin: auto;
        text-align: center;
        margin-bottom:1em;
      }
      .form-subtitle {
        max-width: $max-width;
        margin: auto;
        padding: 2em 0;
      }
      form {
        width: 800px;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: 1fr;
        grid-gap: 2em;
        .input-w {
          margin:0;
          &:nth-child(4) {
            grid-column: span 3;
          }
          input {
            border-radius: 3px;
          }
        }
        label {
          grid-column: span 3;
        }
        .textarea {
          grid-column: span 3;
          textarea {
            border-radius:3px;
          }
        }
        .button-w {
          grid-column: span 3;
          button {
            border-radius: 0;
            background-image: linear-gradient(180deg, #5ec26c 0%, #409e4d 100%);

            span,
            svg {
              color: white;
              font-family: "Muli", sans-serif;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: $desktop) {
    #seminaires #contact-component form {
      .input-w {
        margin-bottom:20px;
      }
    }
    #seminaires {
      .bloc-image {
        left: 0;
        width: 100%;
        max-width: 100%;
        img {
          margin: auto;
        }
      }
      .slider {
        padding: 0;
      }
      .textBloc {
        max-width: 100%;
        padding: 1em 4%;
      }
      .item-seminaire:nth-child(even) {
        .wrapper {
          transform: translateY(-135px);
          .container {
            p {
              font-size: 12px;
            }
          }
        }
        .content {
          transform: translateX(0px);
          .content-text {
            left: -10px;
            width: 60%;
            top: 30%;
          }
        }
      }
      .item-seminaire:nth-child(odd) {
        .wrapper {
          transform: translateY(-135px);
          right: 15px;
          .container {
            p {
              font-size: 12px;
            }
          }
        }
        .content {
          transform: translateX(0px);
          .content-text {
            right: -20px;
            width: 60%;
            top: 30%;
            text-align: right;
          }
        }
      }
      #contact-component {
        .form-title {
          width: 40%;
        }
      }
      .custom-title {
        #underline-wrapper {
          height: 0px !important;
        }
      }
      .cases {
        .slider {
          .slides {
            li {
              .case-wrapper {
                .case {
                  .slide-content {
                    transform: translateY(160px);
                    .sidebar {
                      display: none;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .grid-wrapper {
        .grid-seminaire {
          .numbers {
            margin: 1em 0;
            margin-left: 1em;
            &:nth-child(5) {
              width: 100%;
            }
            .content {
              .text {
                text-align: center;
                width: 100%;
                p {
                  transform: translateY(20%);
                }
              }
            }
          }
        }
      }
      #contact-component {
        form {
          display: flex;
          flex-direction: column;
          .input-w {
            textarea {
              box-shadow: 0px 0px 0 2px #5dc0d5;
              border-radius: 0;
              font-family: "Quicksand", sans-serif;
            }
          }
        }
      }
    }
  }

  @media screen and (min-width: 767px) {
    #seminaires {
      .bloc-image {
        left: 0;
        width: 100%;
        max-width: 100%;
        img {
          max-width: 25%;
          margin: auto;
        }
      }
      .cases {
        .slider {
          .slides {
            li {
              .case-wrapper {
                .case {
                  .slide-content {
                    transform: translateY(160px);
                    .sidebar {
                      height: 100%;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .textBloc {
        max-width: 100%;
        padding: 1em 4%;
      }
      .contact {
        //background: $primary;
        h2 {
          text-align: center;
          color: #fff;
          padding: 50px 0;
        }
        form {
          width: 400px;
          margin: auto;
          max-width: $max-width;
          .input-w {
            width: 100%;
            display: block;
            margin-bottom: 15px;
            input {
              display: block;
              width: 100%;
              padding: 15px 20px;
              border-radius: 30px;
              border: 1px grey solid;
              font-size: 13px;
            }
          }
          .custom-checkbox {
            p {
              color: black !important;
            }
            margin-bottom: 15px;
          }
          .button-w {
            display: block;
            padding: 20px 0;
            text-align: center;
            button {
              display: flex;
              align-items: center;
              margin: auto;
              padding: 15px 20px;
              border-radius: 30px;
              border: none;
              background-color: #fff;
              justify-content: center;
              font-size: 12px;
              text-transform: uppercase;
              font-family: "Luckiest Guy", cursive;
              box-shadow: 2px 2px 12px 5px rgba(0, 0, 0, 0.17);
              cursor: pointer;
              .icon {
                color: $primary;
                font-size: 250%;
                margin-right: 8px;
              }
              span {
                color: $primary;
              }
            }
          }
        }
      }
    }
  }
  @media screen and (min-width: $tablet) and (max-width: $desktop) {
    #seminaires {
      .item-seminaire:nth-child(even) {
        .wrapper {
          transform: translateY(-135px);
          .container {
            p {
              font-size: 12px;
            }
          }
        }
        .content {
          transform: translateX(0px);
          .content-text {
            left: -10px;
            width: 45%;
            top: 30%;
          }
        }
      }
      .item-seminaire:nth-child(odd) {
        .wrapper {
          transform: translateY(-135px);
          right: 15px;
          .container {
            p {
              font-size: 12px;
            }
          }
        }
        .content {
          transform: translateX(0px);
          .content-text {
            right: -15px;
            width: 45%;
            top: 30%;
            text-align: right;
          }
        }
      }
      .cases {
        .slider {
          .slides {
            li {
              .case-wrapper {
                .case {
                  .slide-content {
                    transform: translateY(230px);
                    .sidebar {
                      display: none;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  @media screen and (max-width: 767px) {
  }
</style>
